<template>
    <el-dialog title="关联业务模板" width="65%" append-to-body :close-on-click-modal="false" :visible.sync="visible">
        <div class="noDataBox p_b2" v-if="!form.dataList.length">
            <img src="@/assets/img/noData.png" class="noData">
            <div class="m_b2">暂无关联业务，请先添加</div>
            <el-button type="primary" @click="addDataList" size="small">添加关联业务</el-button>
        </div>
        <el-form size="mini" :model="form" :inline="true" ref="form" label-width="0px" v-show="form.dataList.length" v-loading="loading">
            <el-card class="m_b1" v-for="(item, index) in form.dataList" :key="index">
                <div class="flex_b_t">
                    <div class="flex_1">
                        <el-form-item class="w100i templateFormItem"
                                      :prop="`dataList.${index}.associationMetadataBasicDataId`"
                                      :rules="[{required: true, message: '元数据模板不能为空', trigger: 'change'}]">
                            <el-select class="w100i" :ref="'ref'+index" v-model="item.associationMetadataBasicDataId"
                                       placeholder="请选择元数据模板" filterable @change="selTemplate($event, item)" @focus="focusTemplate(item)" @visible-change="visibleChangeTemplate($event, index)">
                                <el-option v-for="c in templateOpt" :key="c.id" :label="c.basicDataName"
                                           :value="c.id" :disabled="c.disabled"></el-option>
                            </el-select>
                        </el-form-item>
                        <div class="b_d conditionBox" v-show="item.conditionShow">
                            <div class="setBtn" @click="setDataConditions(item)"
                                 v-if="!item.metadataBasicDataAssociationDetailList.length">+ 点击设置数据条件
                            </div>
                            <div v-if="editFlag">
                                <div v-for="(itemC, indexC) in item.metadataBasicDataAssociationDetailList"
                                     :key="indexC">
                                    <el-form-item
                                            :prop="`dataList[${index}].metadataBasicDataAssociationDetailList[${indexC}].basicDataDetailId`"
                                            :rules="[{required: true, message: '元数据不能为空', trigger: 'change'}]"
                                            label-width="10px">
                                        <el-select v-model="itemC.basicDataDetailId" placeholder="请选择" filterable
                                                   @change="archivesChange(item, itemC)">
                                            <el-option v-for="c in item.children" :key="c.id" :label="c.basicRename"
                                                       :value="c.id"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                            :prop="`dataList[${index}].metadataBasicDataAssociationDetailList[${indexC}].basicCondition`"
                                            :rules="[{required: true, message: '条件不能为空', trigger: 'change'}]"
                                            label-width="10px">
                                        <el-select v-model="itemC.basicCondition" placeholder="请选择"
                                                   @change="conditionChange(itemC)">
                                            <el-option
                                                    :key="v.value"
                                                    :label="v.label"
                                                    :value="v.value"
                                                    v-for="v in $dictUtils.getDictList('condition')">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item
                                            :prop="`dataList[${index}].metadataBasicDataAssociationDetailList[${indexC}].conditionValue`"
                                            :rules="[{required: true, message: '条件值不能为空', trigger: 'change'}, validatorDataRule(itemC)]"
                                            v-if="itemC.basicCondition && itemC.basicCondition != '=null' && itemC.basicCondition != '!=null'"
                                            label-width="10px">
                                        <!--单行文本-->
                                        <el-input v-model.trim="itemC.conditionValue" placeholder="请输入"
                                                  :maxlength="itemC.metadataBasicDataRuleVo && itemC.metadataBasicDataRuleVo.ruleMax ? (itemC.metadataBasicDataRuleVo.ruleMax)*1 : 200"
                                                  clearable
                                                  v-if="itemC.basicAssemblyId == '1'"></el-input>
                                        <!--多行文本-->
                                        <el-input v-model.trim="itemC.conditionValue" placeholder="请输入"
                                                  :maxlength="itemC.metadataBasicDataRuleVo && itemC.metadataBasicDataRuleVo.ruleMax ? (itemC.metadataBasicDataRuleVo.ruleMax)*1 : 2000"
                                                  type="textarea"
                                                  :rows="1" v-if="itemC.basicAssemblyId == '2'"></el-input>
                                        <!--数字-->
                                        <el-input v-model.trim="itemC.conditionValue" placeholder="请输入" clearable
                                                  maxlength="19"
                                                  @input="(v)=>(itemC.conditionValue=v.replace(/[^\d-.]/g,''))"
                                                  v-if="itemC.basicAssemblyId == '12'"></el-input>
                                        <!--下拉单选、单选框组、下拉多选、多选框组-->
                                        <el-select v-model="itemC.conditionValue"
                                                   :multiple="itemC.basicAssemblyId == '6' || itemC.basicAssemblyId == '7'"
                                                   placeholder="请选择" clearable
                                                   v-if="itemC.basicAssemblyId == '4' || itemC.basicAssemblyId == '5' || itemC.basicAssemblyId == '6' || itemC.basicAssemblyId == '7' || itemC.basicAssemblyId == '10'">
                                            <el-option v-for="(v,i) in itemC.basicRangeList" :key="i"
                                                       :label="v.basicRange"
                                                       :value="v.metadataRangeId"></el-option>
                                        </el-select>
                                        <!--时间-->
                                        <el-time-picker v-model="itemC.conditionValue" placeholder="请选择"
                                                        value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                                        clearable v-if="itemC.basicAssemblyId == '8'"></el-time-picker>
                                        <!--日期-->
                                        <el-date-picker v-model="itemC.conditionValue"
                                                        value-format="yyyy-MM-dd HH:mm:ss"
                                                        :format="itemC.metadataBasicDataRuleVo ? itemC.metadataBasicDataRuleVo.ruleDateFormat : 'yyyy-MM-dd HH:mm:ss'"
                                                        :type="setDatePickerType(itemC)"
                                                        clearable placeholder="请选择"
                                                        v-if="itemC.basicAssemblyId == '9'"></el-date-picker>
                                    </el-form-item>
                                    <el-link icon="el-icon-circle-plus" class="m_l1" type="primary" :underline="false"
                                             v-if="editFlag" @click="setDataConditions(item)"></el-link>
                                    <el-link v-if="editFlag" icon="el-icon-remove" class="m_l1" type="danger"
                                             :underline="false"
                                             @click="delCondition(item, indexC)"></el-link>
                                </div>
                            </div>
                            <div class="p_b2" v-if="!editFlag && item.metadataBasicDataAssociationDetailList.length && item.children">
                                <span class="fontSize12">{{getConditionInfo(item)}}</span>
                                <el-link v-if="!editFlag" icon="el-icon-edit" class="m_l1" type="primary"
                                         :underline="false"
                                         @click="editFlag = !editFlag"></el-link>
                                <el-link v-if="!editFlag" icon="el-icon-delete" class="m_l1" type="danger"
                                         :underline="false"
                                         @click="delCondition(item)"></el-link>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-link icon="el-icon-circle-plus" class="m_l1" type="primary" :underline="false"
                                 @click="addAssociationTemplates(item)"></el-link>
                        <el-link icon="el-icon-remove" class="m_l1" type="danger" :underline="false"
                                 @click="delAssociationTemplates(index, item.id)"></el-link>
                        <el-link icon="el-icon-s-operation" class="m_l1" type="primary" :underline="false"
                                 @click="showCondition(item)"></el-link>
                    </div>
                </div>
            </el-card>
        </el-form>
        <div slot="footer" v-if="form.dataList.length">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="doSubmit()" v-noMoreClick>确定</el-button>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        data() {
            return {
                visible: false,
                loading: false,
                editFlag: false,
                basicDataId: '',
                templateOpt: [],
                form: {
                    dataList: [],
                },
                curTemplateId: ''
            }
        },
        methods: {
            init(basicDataId) {
                this.curTemplateId = ''
                this.templateOpt = []
                this.form.dataList = []
                this.basicDataId = basicDataId
                this.editFlag = false
                this.visible = true
                this.getTemplate()
                this.refreshList()
            },
            refreshList() {
                this.loading = true
                this.$axios(this.api.metadata.queryMetadataBasicDataAssociationList, {
                    metadataBasicDataId: this.basicDataId,
                }).then(data => {
                    if (data.status) {
                        this.form.dataList = data.data
                        data.data.map(v => {
                            this.selTemplate(v.associationMetadataBasicDataId, v, 1)
                        })
                        this.editFlag = false
                    }
                    this.loading = false
                })
            },
            // 添加关联业务
            addDataList() {
                this.form.dataList.push({
                    associationMetadataBasicDataId: '',
                    conditionShow: true,
                    metadataBasicDataAssociationDetailList: [],
                })
                this.editFlag = true
            },
            // 查询可以被关联的模板
            getTemplate() {
                this.$axios(this.api.metadata.selectMetadataBasicDataCleanList, [], 'post').then(data => {
                    if (data.status) {
                        data.data.map(opt => {
                            this.$set(opt, 'disabled', false)
                        })
                        this.templateOpt = data.data
                    }
                })
            },
            // 选择元数据模板
            selTemplate(val, item, type) {
                if (type != 1) {
                    this.editFlag = true
                    if(this.curTemplateId) {
                        const h = this.$createElement;
                        this.$msgbox({
                            title: '提示',
                            message: h('p', null, [
                                h('p', {style: 'color: #333333; margin-bottom: 5px'}, '确认修改元数据模板？'),
                                h('p', {style: 'color: #999999; font-size: 12px'}, '修改元数据模板后,原设定的元数据模板数据条件将自动清除，是否继续')
                            ]),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: '继续',
                            cancelButtonText: '取消',
                        }).then(() => {
                            this.$set(item, 'metadataBasicDataAssociationDetailList', [])
                            this.getTemplateChildren(val, item, type)
                        }).catch(() => {
                            this.$set(item, 'associationMetadataBasicDataId', this.curTemplateId)
                            setTimeout(() => {
                                this.curTemplateId = ''
                            },500)
                        })
                    } else {
                        this.getTemplateChildren(val, item, type)
                    }
                } else {
                    this.getTemplateChildren(val, item, type)
                }
            },
            // 获取模板字段
            getTemplateChildren(val, item, type) {
                this.curTemplateId = ''
                this.filterTemplate()
                this.$axios(this.api.metadata.selectMetadataBasicDataCleanList, [val], 'post').then(data => {
                    if (data.status) {
                        let children = data.data[0].children.filter(v => v.basicAssemblyId == '1' || v.basicAssemblyId == '2' || v.basicAssemblyId == '4' || v.basicAssemblyId == '5' || v.basicAssemblyId == '6' || v.basicAssemblyId == '7' || v.basicAssemblyId == '8' || v.basicAssemblyId == '9' || v.basicAssemblyId == '10' || v.basicAssemblyId == '12')
                        this.$set(item, 'children', children)
                        if (type == 1) {
                            item.metadataBasicDataAssociationDetailList.map(m => {
                                this.archivesChange(item, m, 1)
                            })
                        } else {
                        }
                    }
                })
            },
            // 元数据模板聚焦
            focusTemplate(item) {
                if(!this.curTemplateId) {
                    this.curTemplateId = JSON.parse(JSON.stringify(item.associationMetadataBasicDataId))
                }
            },
            // 元数据模板下拉框
            visibleChangeTemplate(val, index) {
                if(!val){
                    this.$refs[`ref${index}`][0].blur()
                }
            },
            // 过滤已选模板
            filterTemplate() {
                this.templateOpt.map(opt => {
                    this.$set(opt, 'disabled', false)
                })
                let opts = this.templateOpt.filter(v => this.form.dataList.some(d => d.associationMetadataBasicDataId == v.id))
                opts.map(item => {
                    this.$set(item, 'disabled', true)
                })
            },
            // 选择元数据字段
            archivesChange(item, itemC, type) {
                let val = item.children.filter(v => v.id == itemC.basicDataDetailId)[0]
                this.$set(itemC, 'basicAssemblyId', val.basicAssemblyId)
                this.$set(itemC, 'basicRangeList', val.basicRangeList)
                this.$set(itemC, 'metadataBasicDataRuleVo', val.metadataBasicDataRuleVo)
                if (type != 1) {
                    this.$set(itemC, 'basicCondition', '')
                    this.$set(itemC, 'conditionValue', null)
                } else {
                    if (itemC.basicAssemblyId != '6' && itemC.basicAssemblyId != '7') {
                        this.$set(itemC, 'conditionValue', itemC.conditionValue[0])
                    }
                }
            },
            // 选择条件
            conditionChange(itemC) {
                this.$set(itemC, 'conditionValue', null)
            },
            // 添加关联模板
            addAssociationTemplates(item) {
                let flag = this.form.dataList.filter(v => !v.associationMetadataBasicDataId).length
                if (flag > 0) {
                    this.$message.warning('请选择元数据模板！')
                    return
                }
                this.addDataList()
            },
            // 删除关联模板
            delAssociationTemplates(index) {
                const h = this.$createElement;
                this.$msgbox({
                    title: '提示',
                    message: h('p', null, [
                        h('p', {style: 'color: #333333; margin-bottom: 5px'}, '确认删除元数据模板？'),
                        h('p', {style: 'color: #999999; font-size: 12px'}, '删除后元数据模板设置的数据条件按同步删除，删除后的数据不可恢复，是否继续')
                    ]),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: '继续',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.form.dataList.splice(index, 1)
                    this.editFlag = true
                    this.$nextTick(() => {
                        this.doSubmit()
                    })
                })
            },
            // 条件隐藏显示
            showCondition(item) {
                if (!item.conditionShow) {
                    this.$set(item, 'conditionShow', true)
                } else {
                    this.$set(item, 'conditionShow', false)
                }
            },
            // 设置数据条件
            setDataConditions(item) {
                this.editFlag = true
                if (!item.associationMetadataBasicDataId) {
                    this.$message.warning('请选择元数据模板！')
                    return
                }
                item.metadataBasicDataAssociationDetailList.push({
                    basicDataDetailId: '',
                    basicCondition: '',
                    conditionValue: null,
                })
            },
            // 删除条件
            delCondition(item, index) {
                const h = this.$createElement;
                this.$msgbox({
                    title: '提示',
                    message: h('p', null, [
                        h('p', {style: 'color: #333333; margin-bottom: 5px'}, '确认删除数据条件？'),
                        h('p', {style: 'color: #999999; font-size: 12px'}, '删除后数据不可恢复，是否继续')
                    ]),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: '继续',
                    cancelButtonText: '取消',
                }).then(() => {
                    if(index) {
                        item.metadataBasicDataAssociationDetailList.splice(index, 1)
                    } else {
                        this.$set(item, 'metadataBasicDataAssociationDetailList', [])
                    }
                })
            },
            // 展示条件
            getConditionInfo(item) {
                let val = ''
                item.metadataBasicDataAssociationDetailList.map((v, i) => {
                    val = val + v.basicRename + this.$dictUtils.getDictLabel("condition", v.basicCondition, '')
                    if(Array.isArray(v.conditionValue)) {
                        let field = item.children.filter(f => f.id == v.basicDataDetailId)
                        let basicRangeList = field.length ? field[0].basicRangeList : []
                        v.conditionValue.map((c, k) => {
                            let basicRangeArr = basicRangeList.filter(r => r.metadataRangeId == c)
                            if(basicRangeArr && basicRangeArr.length) {
                                let basicRange = basicRangeArr[0].basicRange
                                val += basicRange
                            }
                            if(k < v.conditionValue.length-1) {
                                val  += '、'
                            }
                        })
                    } else {
                        if(v.basicAssemblyId == 4 || v.basicAssemblyId == 5) {
                            let field = item.children.filter(f => f.id == v.basicDataDetailId)
                            let basicRangeList = field.length ? field[0].basicRangeList : []
                            let basicRangeArr = basicRangeList.filter(r => r.metadataRangeId == v.conditionValue)
                            if(basicRangeArr && basicRangeArr.length) {
                                let basicRange = basicRangeArr[0].basicRange
                                val += basicRange
                            }
                        } else {
                            val += v.conditionValue
                        }
                    }
                    if(i < item.metadataBasicDataAssociationDetailList.length-1) {
                        val += '；'
                    }
                })
                return val
            },
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.loading = true
                        let p = JSON.parse(JSON.stringify(this.form.dataList))
                        p.map(item => {
                            delete item.children
                            item.metadataBasicDataAssociationDetailList.map(v => {
                                if (!v.conditionValue) {
                                    v.conditionValue = []
                                } else if (v.conditionValue && !Array.isArray(v.conditionValue)) {
                                    v.conditionValue = [v.conditionValue]
                                }
                            })
                        })
                        this.$axios(this.api.metadata.metadatabasicdataassociationSave + '?metadataBasicDataId=' + this.basicDataId, p, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('保存成功')
                                this.refreshList()
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
        },
    }
</script>

<style scoped>
    .templateFormItem >>> .el-form-item__content {
        width: 100% !important;
    }

    .conditionBox {
        margin-top: -19px !important;
        padding: 18px 10px 0;
    }

    .setBtn {
        cursor: pointer;
        padding-bottom: 15px;
        font-size: 12px;
        color: #7F7F7F;
        text-align: center;
    }
</style>
